// extracted by mini-css-extract-plugin
export default {"page":"ServiceDetail_page__qNg2x"};